import { useState } from "react";

import { DropdownMenu, DropdownMenuItem, DropdownMenuTrigger } from "components/ui/dropdown_menu";
import { createStotlesCalloutBlock } from "../custom_blocks/stotlesCalloutBlock";
import { useStotlesBlockNoteEditor } from "../useStotlesBlockNoteEditor";
import AddStotlesCalloutModal from "./AddStotlesCalloutModal";

export default function ReportItemsDropdownButton() {
  const editor = useStotlesBlockNoteEditor();
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <DropdownMenu
        trigger={<DropdownMenuTrigger buttonType="secondary">Report Items</DropdownMenuTrigger>}
      >
        <DropdownMenuItem
          icon="alertCircle"
          onClick={() => {
            setIsModalOpen(true);
          }}
        >
          Stotles callout
        </DropdownMenuItem>
      </DropdownMenu>
      <AddStotlesCalloutModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onSubmit={(props) => {
          const currentBlock = editor.getTextCursorPosition().block;
          editor.insertBlocks([createStotlesCalloutBlock(props)], currentBlock, "after");
        }}
      />
    </>
  );
}
